/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_WeightInputs */

const en_us2_search_field_weight = /** @type {(inputs: Search_Field_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const pt_br2_search_field_weight = /** @type {(inputs: Search_Field_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const es_419_search_field_weight = /** @type {(inputs: Search_Field_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const pt_pt2_search_field_weight = /** @type {(inputs: Search_Field_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const fr_fr2_search_field_weight = /** @type {(inputs: Search_Field_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids`)
};

const de_de2_search_field_weight = /** @type {(inputs: Search_Field_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht`)
};

const it_it2_search_field_weight = /** @type {(inputs: Search_Field_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

/**
* | output |
* | --- |
* | "Weight" |
*
* @param {Search_Field_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_weight = /** @type {((inputs?: Search_Field_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_weight(inputs)
	if (locale === "es-419") return es_419_search_field_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_weight(inputs)
	if (locale === "de-DE") return de_de2_search_field_weight(inputs)
	if (locale === "it-IT") return it_it2_search_field_weight(inputs)
	return en_us2_search_field_weight(inputs)
});
export { search_field_weight as "search.field_weight" }